// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2hQoO","notes":"Notes_notes__3yrpT"};